'use client';

import { c as _c } from "react/compiler-runtime";
import type { FundingProvider, FundingSavedCard } from '@morfi/onramp-sdk';
import { useFundingCardRemoval } from '@morfi/onramp-sdk/react';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Delete02Icon } from '@/components/ui/icon/glyphs';
import { Panel } from '@/components/ui/panel';
import { SilkSheet } from '@/components/ui/silk-sheet';
import { logger } from '@/lib/telemetry/logger';
import { useFundingCardLabel } from '../shared/use-funding-card-label';
export function FundingProfileCards(t0) {
  const $ = _c(76);
  const {
    cards,
    unavailable,
    refreshing,
    onRefresh,
    onAdd,
    provider
  } = t0;
  const t = useTranslations("onramp");
  const removal = useFundingCardRemoval(provider, onRefresh, _temp);
  const blocked = refreshing || removal.pending;
  let t1;
  if ($[0] !== t) {
    t1 = t("saved_cards_title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <h3 className="text-heading-sm">{t1}</h3>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== blocked || $[5] !== cards || $[6] !== provider || $[7] !== removal || $[8] !== unavailable) {
    let t4;
    if ($[10] !== blocked || $[11] !== provider || $[12] !== removal || $[13] !== unavailable) {
      t4 = card => <SavedCard key={card.id} card={card} open={removal.selected?.id === card.id} disabled={blocked || unavailable || !provider.deletePaymentMethod} onRemove={() => removal.select(card)} />;
      $[10] = blocked;
      $[11] = provider;
      $[12] = removal;
      $[13] = unavailable;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = cards.map(t4);
    $[4] = blocked;
    $[5] = cards;
    $[6] = provider;
    $[7] = removal;
    $[8] = unavailable;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[15] !== cards.length || $[16] !== onRefresh || $[17] !== refreshing || $[18] !== t || $[19] !== unavailable) {
    t4 = unavailable ? <><p role="alert" className="text-caption text-foreground-secondary">{t("saved_cards_load_failed")}</p><AnimatedButton variant="secondary" disabled={refreshing} onClick={onRefresh}>{t("retry")}</AnimatedButton></> : cards.length === 0 ? <p className="text-caption text-foreground-secondary">{t("saved_cards_empty")}</p> : null;
    $[15] = cards.length;
    $[16] = onRefresh;
    $[17] = refreshing;
    $[18] = t;
    $[19] = unavailable;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== refreshing || $[22] !== t3 || $[23] !== t4) {
    t5 = <Panel density="flush" surface="none" inheritBackground={true} className="gap-3 rounded-control bg-background-tertiary p-4" aria-busy={refreshing}>{t3}{t4}</Panel>;
    $[21] = refreshing;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== t) {
    t6 = t("add_card");
    $[25] = t;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== blocked || $[28] !== onAdd || $[29] !== t6) {
    t7 = <AnimatedButton variant="secondary" disabled={blocked} onClick={onAdd}>{t6}</AnimatedButton>;
    $[27] = blocked;
    $[28] = onAdd;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  const t8 = removal.selected !== null;
  let t9;
  if ($[31] !== blocked || $[32] !== removal) {
    t9 = open => {
      if (!blocked && !open) {
        removal.select(null);
      }
    };
    $[31] = blocked;
    $[32] = removal;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] !== t) {
    t10 = t("remove_card_title");
    $[34] = t;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== t) {
    t11 = t("remove_card_body");
    $[36] = t;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== t11) {
    t12 = <p className="text-body text-foreground-secondary">{t11}</p>;
    $[38] = t11;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== removal.failed || $[41] !== t) {
    t13 = removal.failed ? <p role="alert" className="text-caption text-foreground-secondary">{t("remove_card_failed")}</p> : null;
    $[40] = removal.failed;
    $[41] = t;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  const t14 = removal.pending;
  let t15;
  if ($[43] !== removal) {
    t15 = () => {
      removal.confirm();
    };
    $[43] = removal;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== t) {
    t16 = t("remove_card");
    $[45] = t;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] !== blocked || $[48] !== removal.pending || $[49] !== t15 || $[50] !== t16) {
    t17 = <AnimatedButton variant="destructive" loading={t14} disabled={blocked} onClick={t15}>{t16}</AnimatedButton>;
    $[47] = blocked;
    $[48] = removal.pending;
    $[49] = t15;
    $[50] = t16;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== removal) {
    t18 = () => removal.select(null);
    $[52] = removal;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  let t19;
  if ($[54] !== t) {
    t19 = t("cancel");
    $[54] = t;
    $[55] = t19;
  } else {
    t19 = $[55];
  }
  let t20;
  if ($[56] !== blocked || $[57] !== t18 || $[58] !== t19) {
    t20 = <AnimatedButton variant="tertiary" disabled={blocked} onClick={t18}>{t19}</AnimatedButton>;
    $[56] = blocked;
    $[57] = t18;
    $[58] = t19;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  let t21;
  if ($[60] !== t12 || $[61] !== t13 || $[62] !== t17 || $[63] !== t20) {
    t21 = <div className="flex flex-col gap-4">{t12}{t13}{t17}{t20}</div>;
    $[60] = t12;
    $[61] = t13;
    $[62] = t17;
    $[63] = t20;
    $[64] = t21;
  } else {
    t21 = $[64];
  }
  let t22;
  if ($[65] !== blocked || $[66] !== t10 || $[67] !== t21 || $[68] !== t8 || $[69] !== t9) {
    t22 = <SilkSheet open={t8} onOpenChange={t9} title={t10} guardDismiss={blocked} size="sm" sheetClassName="scrollbar-none [&_*]:scrollbar-none">{t21}</SilkSheet>;
    $[65] = blocked;
    $[66] = t10;
    $[67] = t21;
    $[68] = t8;
    $[69] = t9;
    $[70] = t22;
  } else {
    t22 = $[70];
  }
  let t23;
  if ($[71] !== t2 || $[72] !== t22 || $[73] !== t5 || $[74] !== t7) {
    t23 = <section className="flex flex-col gap-3">{t2}{t5}{t7}{t22}</section>;
    $[71] = t2;
    $[72] = t22;
    $[73] = t5;
    $[74] = t7;
    $[75] = t23;
  } else {
    t23 = $[75];
  }
  return t23;
}
function _temp(code) {
  logger.warn("onramp.card_deletion_failed", {
    code,
    surface: "web"
  });
}
function SavedCard(t0) {
  const $ = _c(20);
  const {
    card,
    open,
    disabled,
    onRemove
  } = t0;
  const t = useTranslations("onramp");
  const label = useFundingCardLabel(card);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <OptimizedImage nsfw={false} variant="thumbnail" preview={false} loadReveal="none" rounded="" imageClassName="object-contain" src="/assets/onramp/method-card.png" alt="" size="size-8" className="bg-transparent" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <span className="text-body font-medium">{label}</span>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== card.availability.active || $[4] !== t) {
    t3 = !card.availability.active ? <span className="text-caption text-foreground-secondary">{t("card_unavailable")}</span> : null;
    $[3] = card.availability.active;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-1 flex-col gap-1">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== card.last4 || $[10] !== t) {
    t5 = t("remove_card_label", {
      last4: card.last4
    });
    $[9] = card.last4;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = disabled || !card.allowsDeletion;
  let t7;
  if ($[12] !== onRemove || $[13] !== open || $[14] !== t5 || $[15] !== t6) {
    t7 = <AnimatedButton variant="tertiary" prefix={Delete02Icon} aria-label={t5} aria-haspopup="dialog" aria-expanded={open} disabled={t6} onClick={onRemove} />;
    $[12] = onRemove;
    $[13] = open;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t7) {
    t8 = <div className="flex items-center gap-3">{t1}{t4}{t7}</div>;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}